import { render, staticRenderFns } from "./ImportJobDescriptionOverlay.vue?vue&type=template&id=c6ca32b4&scoped=true"
import script from "./ImportJobDescriptionOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportJobDescriptionOverlay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ImportJobDescriptionOverlay.vue?vue&type=style&index=0&id=c6ca32b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca32b4",
  null
  
)

export default component.exports